import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const enemyVariables = `
    enemies;
    enemySpawnRate = 500;
    nextEnemySpawn = 0;
`

const getEnemySnippet = `
    this.load.spritesheet("enemy", "EnemySpriteSheet.png", {
      frameWidth: 266,
      frameHeight: 122
    });
`

const enemyAnimSnippet = `
    // Create Enemy Animation
    var enemyAnimConfig = {
      key: "enemyAnimation",
      frames: this.anims.generateFrameNumbers("enemy", {
        start: 0,
        end: 2,
        first: 0
      }),
      frameRate: 10,
      repeat: -1
    };

    this.anims.create(enemyAnimConfig);
`

const enemyGroupSnippet = `
    this.enemies = this.physics.add.group();
    this.enemies.createMultiple({
      key: "enemy",
      quantity: 15,
      active: false,
      visible: false
    });
`

const enemyOutOfBoundsSnippet = `
    this.enemies.children.each((enemy) => {
      if (enemy.x < -50) {
        enemy.disableBody(true, true);
      }
    });

    this.playerBullets.children.each((bullet) => {
      if (bullet.x > 1285) {
        bullet.disableBody(true, true);
      }
    });
`

const generateEnemySnippet = `
  generateEnemy(dt) {
    this.nextEnemySpawn -= dt;
    if (this.nextEnemySpawn > 0) {
      return;
    }
    const enemy = this.enemies.getFirstDead();
    if (enemy === undefined || enemy == null) {
      return;
    }
    
    enemy.enableBody(true, 1300, Phaser.Math.Between(50, 450), true, true);
    enemy.setScale(0.3);
    enemy.body.velocity.x -= Phaser.Math.Between(100, 350);
    enemy.play("enemyAnimation");

    this.nextEnemySpawn = this.enemySpawnRate;
  }
`

const Enemies = () => (
  <>
    <h1>Enemies</h1>
    <p>
      Now that are plane is flying around and shooting it would be a lot more
      fun if we had something to shoot at, so lets make some enemy planes.
    </p>
    <p>
      First lets create some new variables for our enemies, add these variables
      near the other ones we have created.
    </p>
    <CopyBlock
      text={enemyVariables}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we need to tell phaser the name of our enemy plane sprite sheet, add
      this to the preload function:
    </p>
    <CopyBlock
      text={getEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Just like the player animation we need to set up animation for our
      enemies, add this to the create function:
    </p>
    <CopyBlock
      text={enemyAnimSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Since we want multiple enemies to shoot at we need to make a new group.
      Lets create an enemy group below our enemy animation code also in the
      create function.
    </p>
    <CopyBlock
      text={enemyGroupSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      The last thing we need to do is to create the logic for our enemies. Lets
      add a check to make sure the enemies dont't go out of our screen too far.
      Add this logic to the update function to reset them if they do:{" "}
    </p>
    <CopyBlock
      text={enemyOutOfBoundsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Next we are going to make a new function to generate our enemies. Paste
      the following code below our update function.
    </p>
    <CopyBlock
      text={generateEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      The last thing we need to do is tell our update function to call our new
      generateEnemy function. Paste this in the update function:{" "}
    </p>
    <CopyBlock
      text={`this.generateEnemy(dt);`}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      You should now see lots of enemy planes flying across the game screen.
    </p>
    <br />
    <br />
    <Button type="button" variant="secondary" href="/CollisionDetection">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default Enemies
